module.exports = __webpack_public_path__ + "img/loading-bars.a8a43111.svg";